import { useEffect } from 'react';
import { useAB } from 'Douleutaras/app/lib/ab';
import {
  JOB_MODAL_CLOSE_MESSAGE,
  JOB_MODAL_OPEN_MESSAGE
} from 'Design-system/app/static/scripts/support-widget';

// Send event messages on modal Open / Close (used in mobile app webview)
export const useJobModalLifecycle = (): void => {
  const ab = useAB();

  useEffect(() => {
    // @AB-Service
    ab.captureJobFormOpened();

    window.postMessage(JOB_MODAL_OPEN_MESSAGE, window.location.origin);

    // Add iOS height hack when modal opens
    document.body.style.height = '100vh';
    document.body.style.height = '100dvh';

    return () => {
      window.postMessage(JOB_MODAL_CLOSE_MESSAGE, window.location.origin);

      // Remove iOS height hack when modal closes
      document.body.style.removeProperty('height');
    };
  }, []);
};
